import React from 'react';

import { ErrorBoundaryLayout } from '../layouts/ErrorBoundaryLayout/ErrorBoundaryLayout';

export const NotFoundPage = () => (
  <div data-test="not-found-page">
    <ErrorBoundaryLayout errorMessage="Page not found. Please try something else" />
  </div>
);
